<template>
  <div class="body-area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <img :src="$store.state.modalImages[Math.round(Math.random() * 15) + 1]" class="w-100" />
        </div>
        <div class="col-12 text-center py-4">
          <h1 class="fs-24 fc-2">TEBRİKLER!</h1>
          <h2
            class="fs-24 fc-2 font-weight-normal"
          >{{$route.params.data.message.replace('[PUAN]', $route.params.data.bonus && $route.params.data.bonus.value ? $route.params.data.value + ' + ' + $route.params.data.bonus.value : $route.params.data.value)}}</h2>
          <h3
            class="fs-16 fc-2 font-weight-bold"
          >Fan Club Puanın: {{$route.params.data.user.total_point}}</h3>
          <button class="ignore-button mt-4" @click="$router.go(-1)">Geri Dön</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success"
};
</script>


// WEBPACK FOOTER //
// src/pages/Success.vue